import { F0AvatarPerson, F0Box, F0Text } from '@factorialco/f0-react'
import { AtsRequisitionNoteFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import { stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

interface Props {
  requisition: AtsRequisitionNoteFragment
}

export const RequisitionNote = ({ requisition }: Props) => {
  const author = requisition.author?.employee
  const fullName = author ? `${author.firstName ?? ''} ${author.lastName ?? ''}`.trim() : ''

  const relativeTime = stringToDate(requisition.createdAt, 'backend_datetime').fromNow()

  return (
    <F0Box display="flex" flexDirection="column" gap="md">
      <F0Box background="secondary" padding="md" borderRadius="md">
        <F0Text
          variant="body"
          content={requisition.note ?? i18n.t('ats.vacancies.detail.no_notes')}
        />
      </F0Box>
      {author && (
        <F0Box display="flex" flexDirection="row" alignItems="center" gap="sm">
          <F0AvatarPerson
            firstName={author.firstName ?? ''}
            lastName={author.lastName ?? ''}
            src={buildUrl(author.avatar?.url ?? '')}
            size="sm"
          />
          <F0Text variant="description" content={`${fullName} · ${relativeTime}`} />
        </F0Box>
      )}
    </F0Box>
  )
}
